const earningsDrilldownPT = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtros",
                "monthRange": "Intervalo de Meses",
                "startingMonth": "Mês de Início",
                "endingMonth": "Mês de Término",
                "label": "Gravadora",
                "store": "Loja",
                "release": "Lançamento",
                "track": "Faixa",
                "country": "País",
                "subuser": "Subusuário",
                "fetchingEarnings": "Buscando estatísticas de ganhos no banco de dados"
            },
            "button": {
                "generateReport": "Gerar Relatório",
                "resetFilters": "Redefinir Filtros"
            },
            "options": {
                "store": {
                    "selectStore": "Selecionar Loja",
                    "allStores": "Todas as Lojas"
                },
                "label": {
                    "selectLabel": "Selecionar Gravadora"
                },
                "country": {
                    "allCountries": "Todos os Países"
                },
                "release": {
                    "allReleases": "Todos os Lançamentos"
                },
                "track": {
                    "allTracks": "Todas as Faixas"
                },
                "subuser": {
                    "selectSubuser": "Selecionar Subusuário"
                },
                "period": {
                    "selectMonthRange": "Selecionar Intervalo de Meses",
                    "last3Reports": "Últimos 3 Relatórios",
                    "last6Reports": "Últimos 6 Relatórios",
                    "last12Reports": "Últimos 12 Relatórios",
                    "custom": "Personalizado"
                }
            },
            "validation": {
                "monthRangeRequired": "* O filtro de Intervalo de Meses é obrigatório",
                "labelRequired": "* O filtro de Gravadora é obrigatório"
            }
        },
        "royaltiesSummary": {
            "title": "Resumo de Royalties",
            "subtitle": "Visão geral do Intervalo de Meses selecionado",
            "label": {
                "monthRangeText": "Últimos 12 Extratos",
                "revenueEUR": "Receita (€)",
                "combinedRevenue": "Receita Combinada",
                "combinedRevenueEUR": "Receita Combinada (€)",
                "otherStores": "Outras Lojas"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Percentual de Receita por Loja"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Detalhamento de Receita por Loja",
            "label": {
                "revenue": "Receita"
            }
        },
        "revenueByTerritory": {
            "title": "Receita por Território"
        },
        "top5Releases": {
            "title": "Top 5 Lançamentos",
            "table": {
                "column": {
                    "releaseName": "Nome do Lançamento",
                    "revenue": "Receita"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Faixas",
            "table": {
                "column": {
                    "trackName": "Nome da Faixa",
                    "revenue": "Receita"
                }
            }
        },
        "message": {
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>renove</1> sua assinatura para utilizar este recurso.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso."
        }
    }
};

export default earningsDrilldownPT;